export default {
    buscar: "Search",
    categoria: "Category",
    sucursal: "Branch",
    depto: "Department/Area",
    asignado: "Assigned to",
    fechaIni: "Start date",
    fechaFin: "End date",
    fechaPromIni: "Promised start date",
    fechaPromFin: "Promised end date",
    estado: "Status",
    finalizadas: "Completed orders",
    entregados: "Delivered equipment",
    desde: "From",
    hasta: "To",
    fecha: "Date",
    tipoServicio: "Service type",
    grado: "Grade",
    agendadoDesde: "Scheduled from",
    agendadoHasta: "Scheduled to",
    origen: "Origin branch",
    destino: "Destination branch",
    usuario: "User",
    obra: "Work",
    nroInventario: "Inventory number",
    codBarras: "Barcode",
}
